import { render, staticRenderFns } from "./FieldCommentIndicator.vue?vue&type=template&id=c6d6e510&scoped=true&"
import script from "./FieldCommentIndicator.vue?vue&type=script&lang=js&"
export * from "./FieldCommentIndicator.vue?vue&type=script&lang=js&"
import style0 from "./FieldCommentIndicator.vue?vue&type=style&index=0&id=c6d6e510&scoped=true&lang=css&"
import style1 from "./FieldCommentIndicator.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d6e510",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBadge,VBtn,VIcon,VMenu})
